// src/terms/CookiePolicy.jsx
import React from "react";
import { ReactComponent as Cookies_icon } from "../icons/Cookies_icon.svg";


export function CookiePolicy() {
  const wrap = {
    borderRadius: 12,
    background: "#1B202B",
    border: "1px solid rgba(77,100,141,0.9)",
    boxShadow:
      "inset 0 1px 0 rgba(255,255,255,.04), 0 8px 18px rgba(0,0,0,.85)",
    padding: "16px 18px 18px",
    boxSizing: "border-box",
    height: "100%",
    overflowY: "auto",
  };

  const h1 = {
    fontFamily: "DisplayBadge, system-ui, sans-serif",
    fontSize: "var(--fs-18, 18px)",
    letterSpacing: ".18em",
    textTransform: "uppercase",
    color: "#ff8800",
    margin: "0 0 12px",
  };

  const h2 = {
    fontSize: "var(--fs-12, 12px)",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    marginTop: 15,
    marginBottom: 0,
    color: "#82c3ff",
  };

  const p = {
    fontSize: "var(--fs-12, 12px)",
    lineHeight: 1.1,
    color: "rgba(220,230,245,0.88)",
    margin: "1px 0",
  };

  const small = {
    fontSize: 12,
    lineHeight: 1.5,
    color: "rgba(180,190,210,0.75)",
    marginTop: 10,
  };

  const codeBox = {
    fontFamily: " DisplayBadge ",
    fontSize: 11,
    background: "rgba(0,0,0,0.25)",
    borderRadius: 2,
    padding: "6px 8px",
    marginTop: 6,
    marginBottom: 6,
  };

  return (
    <div style={wrap}>
     <h1 style={{
    ...h1,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 30,
  }}
>
  <Cookies_icon
    width={28}
    height={28}
    aria-hidden="true"
    style={{ flexShrink: 0, transform: "translateY(-0.5px)" }}
  />
  <span>LegendsTools Cookie Policy</span></h1>

      {/* Anbieter */}
      <h2 style={h2}>1. Anwendungsbereich:</h2>
      <p style={p}>Diese Cookie Policy gilt in Bezug auf die Webseiten von mts-individual unter dem Label "LegendsTools" für den europäischen Markt, 
      die von der mts individual carstyling GmbH angeboten werden, ergänzend zu den allgemeinen Datenschutzhinweisen und gibt unter Berücksichtigung 
      der Vorgaben aus der Datenschutzgrundverordnung (DSGVO) und aus dem Telekommunikation-Digitale-Dienste-Datenschutz-Gesetz (TDDDG) zusätzliche 
      Informationen zu Art, Umfang und Zwecken der Datenverarbeitung bei eingesetzten Cookies und ähnlichen Technologien (nachfolgend kurz „Cookies“).</p>
      <br />
      <p style={p}>Unsere Website nutzt ausschließlich technisch erforderliche Cookies. Diese kleinen Textdateien werden auf Ihrem Endgerät gespeichert, um grundlegende Funktionen der Website bereitzustellen und die sichere Nutzung zu ermöglichen.
      Es kommen keine Tracking-, Analyse-, Werbe- oder Drittanbieter-Cookies zum Einsatz.</p>
      
      {/* Vertretungsberechtigter */}
      <h2 style={h2}>2. Kategorien der eingesetzten Cookies</h2>
      <p style={p}>Wir verwenden nur folgende Kategorien technisch notwendiger Cookies:</p>
      <br />
      <p style={p}>a) Session-Cookies
      <br />
      (z. B. session_id)
      Diese Cookies werden benötigt, um Deine Anmeldung (Login-Session) aufrechtzuerhalten und die sichere Nutzung Deines Nutzerkontos zu ermöglichen.
      Sie werden automatisch gelöscht, sobald Du Dich abmeldest oder Deinen Browser schließt.</p>
      <br />
      <p style={p}>b) Sicherheitsrelevante Cookies
      <br />
      Diese Cookies schützen unsere Website vor Angriffen, Missbrauch oder unbefugten Zugriffen.</p>
      <br />
      <p style={p}>c) Einstellungen im Browser (LocalStorage)

      Für Komfortfunktionen verwenden wir zusätzlich LocalStorage — keine Cookies. Es werden ausschließlich gespeichert:
      <br />
      • ausgewählte Sprache
      <br />
      • ausgewählte Spielwelt
      <br />
      • Schriftgrößen-/Darstellungsoptionen</p>
      
      <br />
      <p style={p}>Diese Daten werden nicht an uns übermittelt, sondern verbleiben auf Ihrem Gerät.</p>


      {/* 3. COOKIES */}
      <h2 style={h2}>3. Rechtsgrundlage</h2>
      <p style={p}>Die Nutzung technisch notwendiger Cookies erfolgt auf Basis von:</p>
      <br />
      <p style={p}>• Art. 6 Abs. 1 lit. b DSGVO – Bereitstellung von Funktionen, die Sie angefordert haben (Login, Kontofunktionen)</p>
      <p style={p}>• Art. 6 Abs. 1 lit. c DSGVO – Erfüllung gesetzlicher Pflichten (z. B. Sicherheitsanforderungen)</p>
      <p style={p}>• Art. 6 Abs. 1 lit. f DSGVO – unser berechtigtes Interesse am sicheren, stabilen und funktionsfähigen Betrieb der Website</p>
      <br />
      <p style={p}>Hinweis:Da ausschließlich notwendige Cookies verwendet werden, ist keine Einwilligung durch ein Cookie-Banner erforderlich.</p>


      {/* 4. KONTAKT */}
      <h2 style={h2}>4. Möglichkeiten gegen die Verwendung von Cookies und ähnlichen Technologien</h2>
      <p style={p}>
      Wenn Du den Einsatz von bestimmten Technologien oder generell von Cookies nicht wünschst, kannst Du stattdessen auch deren Speicherung auf 
      Deinem Endgerät durch entsprechende Einstellungen Deines Endgeräts und/oder Internetbrowsers verhindern.
      Du kannst in Deinen Internetbrowser-Einstellungen „keine Cookies akzeptieren“ wählen. Die Verfahren zur Verwaltung und Löschung von Cookies
      in den Einstellungen Deines Internetbrowsers entnimmst Du bitte der Hilfe-Funktion Deines Internetbrowsers. 
      </p>
      <br />
      <p style={p}>Gespeicherte Cookies kannst Du in den Systemeinstellungen Deines Endgeräts und/oder Internetbrowsers jederzeit löschen.
      <br />
      <br />
      Bitte beachte, dass die Funktionsfähigkeit und der Funktionsumfang unseres Angebots eingeschränkt sein können, sofern Du Cookies oder ähnliche
      Technologien blockierst oder keine Einwilligung in deren Nutzung erteilst.</p>
      

      <div style={small}>
      Copyright © 2025 mts individual carstyling GmbH, Germany. Alle Rechte vorbehalten.
      <br />
      Legendstools ist ein digitales Angebot der mts individual carstyling GmbH.
      mts individual® ist eingetragenes Warenzeichen der mts individual carstyling GmbH. 
      </div>
    </div>
  );
}


